import { render, staticRenderFns } from "./Apaccountapply.vue?vue&type=template&id=21125003"
import script from "./Apaccountapply.vue?vue&type=script&lang=js"
export * from "./Apaccountapply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports